// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2kqGD","footer":"ModalUpdate_footer__XBMcu"};